var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// @ts-nocheck
import { EyeMuiChoices } from "../../Params";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
var analyzedResultTextCases = function (_a) {
    var result = _a.result, setFunc = _a.setFunc, translate = _a.translate;
    var resultInfos = [
        { type: "both", text: translate("pages.exam.fp.resTextCases.both"), bgColor: "green", icon: CheckCircleIcon },
        { type: "none", text: translate("pages.exam.fp.resTextCases.none"), bgColor: "#d93d3d", icon: ErrorIcon },
        { type: "toomuch", text: translate("pages.exam.fp.resTextCases.toomuch"), bgColor: "#d93d3d", icon: ErrorIcon },
        { type: "lackRight-macula", text: translate("pages.exam.fp.resTextCases.lackRight-macula"), bgColor: "#ecaa00", icon: WarningIcon },
        { type: "lackLeft-macula", text: translate("pages.exam.fp.resTextCases.lackLeft-macula"), bgColor: "#ecaa00", icon: WarningIcon },
        { type: "lackRight-both", text: translate("pages.exam.fp.resTextCases.lackRight-both"), bgColor: "#ecaa00", icon: WarningIcon },
        { type: "lackLeft-both", text: translate("pages.exam.fp.resTextCases.lackLeft-both"), bgColor: "#ecaa00", icon: WarningIcon },
        { type: "lackRight-disc", text: translate("pages.exam.fp.resTextCases.lackRight-disc"), bgColor: "#ecaa00", icon: WarningIcon },
        { type: "lackLeft-disc", text: translate("pages.exam.fp.resTextCases.lackLeft-disc"), bgColor: "#ecaa00", icon: WarningIcon },
    ];
    switch (result) {
        case "both":
            setFunc(resultInfos[0]);
            break;
        case "none":
            setFunc(resultInfos[1]);
            break;
        case "toomuch":
            setFunc(resultInfos[2]);
            break;
        case "lackRight-macula":
            setFunc(resultInfos[3]);
            break;
        case "lackLeft-macula":
            setFunc(resultInfos[4]);
            break;
        case "lackRight-both":
            setFunc(resultInfos[5]);
            break;
        case "lackLeft-both":
            setFunc(resultInfos[6]);
            break;
        case "lackRight-disc":
            setFunc(resultInfos[7]);
            break;
        case "lackLeft-disc":
            setFunc(resultInfos[8]);
            break;
    }
};
var updateAnalyzedResultTextCases = function (givenImgRow, setAnalyzedResultInfo, translate) {
    var checkGradResult = {
        leftMacula: 0,
        rightMacula: 0,
        leftDisc: 0,
        rightDisc: 0
    };
    var newGivenImgRow = __spreadArray([], givenImgRow, true);
    newGivenImgRow === null || newGivenImgRow === void 0 ? void 0 : newGivenImgRow.forEach(function (el) {
        if (el.gradable) {
            if (el.right && el.center) {
                checkGradResult.rightMacula += 1;
            }
            if (!el.right && el.center) {
                checkGradResult.leftMacula += 1;
            }
            if (el.right && !el.center) {
                checkGradResult.rightDisc += 1;
            }
            if (!el.right && !el.center) {
                checkGradResult.leftDisc += 1;
            }
        }
    });
    var textType;
    // Check if all counts are zero
    if (checkGradResult.leftMacula === 0 && checkGradResult.rightMacula === 0 &&
        checkGradResult.leftDisc === 0 && checkGradResult.rightDisc === 0) {
        analyzedResultTextCases({ result: "none", setFunc: setAnalyzedResultInfo, translate: translate });
        textType = null;
    }
    // Check for multiple images in any position
    else if (checkGradResult.leftMacula > 1 || checkGradResult.rightMacula > 1 ||
        checkGradResult.leftDisc > 1 || checkGradResult.rightDisc > 1) {
        analyzedResultTextCases({ result: "toomuch", setFunc: setAnalyzedResultInfo, translate: translate });
        textType = null;
    }
    // Check if both eyes have complete sets
    else if (checkGradResult.leftMacula === 1 && checkGradResult.leftDisc === 1 &&
        checkGradResult.rightMacula === 1 && checkGradResult.rightDisc === 1) {
        textType = EyeMuiChoices[2].label;
        analyzedResultTextCases({ result: "both", setFunc: setAnalyzedResultInfo, translate: translate });
    }
    // Check if neither eye has both macula and disc
    else if ((checkGradResult.leftMacula === 0 || checkGradResult.leftDisc === 0) &&
        (checkGradResult.rightMacula === 0 || checkGradResult.rightDisc === 0)) {
        analyzedResultTextCases({ result: "none", setFunc: setAnalyzedResultInfo, translate: translate });
        textType = null;
    }
    // Check for specific cases of missing images
    else if (checkGradResult.rightMacula === 0 && checkGradResult.rightDisc === 0) {
        analyzedResultTextCases({ result: "lackRight-both", setFunc: setAnalyzedResultInfo, translate: translate });
    }
    else if (checkGradResult.rightMacula === 0) {
        analyzedResultTextCases({ result: "lackRight-macula", setFunc: setAnalyzedResultInfo, translate: translate });
    }
    else if (checkGradResult.rightDisc === 0) {
        analyzedResultTextCases({ result: "lackRight-disc", setFunc: setAnalyzedResultInfo, translate: translate });
    }
    else if (checkGradResult.leftMacula === 0 && checkGradResult.leftDisc === 0) {
        analyzedResultTextCases({ result: "lackLeft-both", setFunc: setAnalyzedResultInfo, translate: translate });
    }
    else if (checkGradResult.leftMacula === 0) {
        analyzedResultTextCases({ result: "lackLeft-macula", setFunc: setAnalyzedResultInfo, translate: translate });
    }
    else if (checkGradResult.leftDisc === 0) {
        analyzedResultTextCases({ result: "lackLeft-disc", setFunc: setAnalyzedResultInfo, translate: translate });
    }
    // If no complete set is available
    else {
        analyzedResultTextCases({ result: "none", setFunc: setAnalyzedResultInfo, translate: translate });
        textType = null;
    }
    return textType;
};
//remove duplicate cmt
var removeDuplicateCommentRows = function (givenComments) {
    var comments = (JSON.parse(JSON.stringify(givenComments)));
    comments = comments.reverse();
    if (comments.length > 0) {
        // Create a map to store the latest comment for each unique id
        var uniqueCommentsMap_1 = new Map();
        // Iterate through the comments array to update the uniqueCommentsMap
        comments.forEach(function (comment) {
            // Check if the comment id already exists in the map
            if (uniqueCommentsMap_1.has(comment.id)) {
                // Compare the dates and update if the current comment is newer
                if (comment.date > uniqueCommentsMap_1.get(comment.id).date) {
                    uniqueCommentsMap_1.set(comment.id, comment);
                }
            }
            else {
                uniqueCommentsMap_1.set(comment.id, comment);
            }
        });
        // Get the unique and latest comments from the map
        var uniqueComments = Array.from(uniqueCommentsMap_1.values());
        return uniqueComments;
    }
    return comments;
};
export { updateAnalyzedResultTextCases, removeDuplicateCommentRows };
